// NOTE:
// i18n-js v4 では I18n はクラスのため new が必要。
// 既存コードでは I18n を翻訳（I18n.t(...)）として使用しているため、
// 名前衝突を避けて I18nJS として import し、
// 生成したインスタンスを翻訳用の I18n として globalThis に公開している。
import { I18n as I18nJS } from 'i18n-js'
import ja from '../locales/ja.json'

const I18n = new I18nJS()
I18n.locale = 'ja'
I18n.store(ja)

globalThis.I18n = I18n

export default I18n
